import styled from 'styled-components';
import { Box } from '@mui/material';

const WizardStage = styled(Box)<{
  $index: number;
  $selectedIndex: number;
  $fillHeight?: boolean;
}>`
  display: ${({ $index, $selectedIndex }) =>
    $index === $selectedIndex ? 'block' : 'none'};
  width: 100%;
  ${({ $fillHeight }) =>
    $fillHeight &&
    `
    height: 100%;
    min-height: 0;
    overflow: hidden;
  `}
`;

export default WizardStage;
